// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Izz4d","image":"styles_image__iot1m","box":"styles_box__R_tiR"};